export default (theme) => ({
  root: {
    marginTop: 54,
    marginLeft: 220,
    padding: 15,
    width: "calc(100% - 220px)",
  },
  cardContainer: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
    paddingBottom: 10,
  },
  filterContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filterContainerMoreButton: {
    marginLeft: 10,
  },
  filterStatusbar: {
    display: "flex",
    alignItems: "center",
  },
  inputLabel: {
    fontSize: "13px",
    marginBottom: 9,
  },
  latestChecksItem: {
    paddingTop: 2.79,
    paddingBottom: 2.79,
    borderBottom: "1px solid rgba(0,0,0,.05)",
    "&:last-child": {
      borderBottom: "None",
    },
  },
});
